import axios from 'axios';
import { getAuthHeaders } from '../utils/authUtils';

const tasks = () => `${process.env.REACT_APP_API_URL}/api/v3/tasks`;
const config = () => ({ headers: { ...getAuthHeaders(), 'Content-Type': 'application/json' } });

/** Ready to post, Posted, Also posting on and the Posting panel (rev6 Part 11). */
const PostingService = {
    panel: async (taskId, date) =>
        (await axios.get(`${tasks()}/${taskId}/posting`, { ...config(), params: date ? { date } : undefined })).data,
    readyLanguages: async (taskId) => (await axios.get(`${tasks()}/${taskId}/ready-languages`, config())).data,
    setReady: async (taskId, languages, date) =>
        (await axios.post(`${tasks()}/${taskId}/ready`, { languages, date: date || null }, config())).data,
    setPosted: async (taskId, slot, posted) => axios.post(`${tasks()}/${taskId}/posted`, { slot, posted }, config()),
    setDoneDetails: async (taskId, body) => axios.post(`${tasks()}/${taskId}/done-details`, body, config()),
    setSecondPosting: async (taskId, body) => axios.post(`${tasks()}/${taskId}/second-posting`, body, config()),
};

export default PostingService;
